// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import appHistory from 'app-history';

// Services
import Person from 'services/data/person';
import PhoneNumber from 'services/data/phone-number';

// Components
import { FormCard } from 'components/content-containers/cards';
import PersonForm from 'components/models/person/person-form';
import SVG from 'components/widgets/icons/svg';

// Utils
import archiveItems from 'utils/archive-items';


// Component
class PersonEdit extends React.Component {
  static propTypes = {
    person: PropTypes.object,
    load: PropTypes.func,
    location: PropTypes.object
  };

  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(values) {
    const { person, load, location } = this.props;
    const update = _.clone(values);
    const parts = _.compact(_.split(location.pathname, '/'));
    const url = _.join(_.take(parts, parts.length - 2), '/');

    update.emailAddresses = archiveItems(person.emailAddresses, values.emailAddresses, { _delete: true });
    update.phoneNumbers = archiveItems(person.phoneNumbers, values.phoneNumbers, { _delete: true });
    update.addresses = archiveItems(person.addresses, values.addresses, { _delete: true });

    return Person.update(update)
      .then(() => {
        load();
        appHistory.push(`/${url}/${person.id}/summary`);
      });
  }

  render() {
    const { person } = this.props;
    const emails = Person.getOrderedContactInfo(person.emailAddresses);
    const numbers = Person.getOrderedContactInfo(person.phoneNumbers);
    const addresses = Person.getOrderedContactInfo(person.addresses);

    const initialValues = _.pick(person, ['id', 'firstName', 'lastName', 'role', 'externalAppAuthRoles', 'onCall', 'poPrefix', 'billingRole', 'tags']);
    initialValues.emailAddresses = _.map(emails, email => _.pick(email, ['id', 'email', 'type', 'primary']));
    initialValues.addresses = _.map(addresses, address => _.pick(address, ['id', 'type', 'name', 'address', 'line2', 'city', 'state', 'zip', 'billing']));
    initialValues.phoneNumbers = _.map(numbers, number => _.assign(_.pick(number, ['id', 'type']), { number: PhoneNumber.format(number.number) }));
    initialValues.company = _.get(person, 'company.id');
    initialValues.team = _.get(person, 'team.id');

    return (
      <div className="person-summary flex flex-equal-children">
        <FormCard className="person-form">
          <div className="form-header">
            <SVG src="svg/person.svg" className="person" />
            <h5 className="form-title">Edit Person</h5>
          </div>
          <PersonForm
            initialValues={initialValues}
            onSubmit={this.onSubmit}
          />
        </FormCard>
      </div>
    );
  }
}

// Exports
export default connect((state) => ({
  person: state.people.person,
  location: state.location
}))(PersonEdit);
